/**
 * WebKit (Safari) can leave collapsable `.children` containers at height 0 even when open,
 * especially for nested menus inside an already expanded parent (#6628).
 */
export function resolveFuseNavCollapsableChildrenHeight(isOpen: boolean): string {
    return isOpen ? 'auto' : '0px';
}

export function applyFuseNavCollapsableChildrenHeight(
    element: HTMLElement | null | undefined,
    isOpen: boolean,
): void {
    if (!element) {
        return;
    }

    element.style.height = resolveFuseNavCollapsableChildrenHeight(isOpen);
}
